import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

const LABEL = "text-xs uppercase tracking-wider font-semibold text-muted-foreground";
const STATUS = { APPROVED: "Aprobada", PENDING: "En revisión", REJECTED: "Rechazada", PAUSED: "Pausada", DISABLED: "Desactivada" };

/** WhatsApp template selector; offers to create the SDM test template in Meta if none exists. */
export const TemplatePicker = ({ value, onChange, accountId }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const params = accountId ? { channel_account_id: accountId } : {};
  const load = () => api.get("/wa-templates", { params }).then(({ data: d }) => { setData(d); setError(null); })
    .catch((e) => { setData(null); setError(e?.response?.data?.detail || "No se pudieron leer las plantillas de Meta"); });
  useEffect(() => { load(); }, [accountId]); // eslint-disable-line react-hooks/exhaustive-deps
  const create = async () => {
    setBusy(true);
    try {
      const { data: r } = await api.post("/wa-templates", {}, { params });
      toast.success(`Plantilla «${r.name}» enviada a Meta (${STATUS[r.status] || r.status})`);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Meta rechazó la plantilla"); } finally { setBusy(false); }
  };
  const list = data?.templates || [];
  const hasDefault = list.some((t) => t.name === data?.default?.name);
  return (
    <div data-testid="template-picker">
      <label className={LABEL}>Plantilla aprobada de WhatsApp</label>
      {error && <div className="text-xs text-red-600 mt-1" data-testid="template-error">{error}</div>}
      <Select value={value?.name || ""} onValueChange={(n) => onChange(list.find((t) => t.name === n))}>
        <SelectTrigger className="mt-1" data-testid="campaign-template"><SelectValue placeholder="Selecciona una plantilla" /></SelectTrigger>
        <SelectContent>
          {list.map((t) => (
            <SelectItem key={`${t.name}-${t.language}`} value={t.name} disabled={t.status !== "APPROVED"}>
              {t.name} · {t.language} · {STATUS[t.status] || t.status}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {data && !hasDefault && (
        <Button size="sm" variant="outline" className="mt-2 text-xs" disabled={busy} onClick={create} data-testid="template-create-default">
          {busy ? "Enviando a Meta…" : "Crear plantilla de prueba SDM (sdm_prueba_campana)"}
        </Button>
      )}
      {data && hasDefault && list.find((t) => t.name === data.default.name)?.status === "PENDING" && (
        <div className="text-[11px] text-amber-600 mt-1">La plantilla de prueba está en revisión en Meta (suele tardar de minutos a 24 h).</div>
      )}
      {value?.header_format === "IMAGE" && <div className="mt-2 text-[11px] text-muted-foreground" data-testid="template-has-image">Incluye imagen de encabezado</div>}
      {value?.header_text && <div className="mt-2 text-xs font-semibold">{value.header_text}</div>}
      {value?.body && <div className="mt-2 text-xs whitespace-pre-wrap rounded border border-border bg-secondary/40 p-2" data-testid="template-body">{value.body}</div>}
    </div>
  );
};

export default TemplatePicker;
